export default function LogoutIcon() {
  return (
    <svg
      width="15"
      height="15"
      viewBox="0 0 200 179"
      fill="none"
      style={{ stroke: "black", strokeWidth: "8px" }}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M145.145 92.5717H3.43006C1.5253 92.5717 0 91.0473 0 89.1426C0 87.2378 1.5253 85.7144 3.43006 85.7144H145.145C147.05 85.7144 148.571 87.2378 148.571 89.1426C148.952 91.0473 147.431 92.5717 145.145 92.5717Z"
        fill="#129219"
      />
      <path
        d="M116.574 121.143C115.813 121.143 114.669 120.762 113.907 120C112.383 118.476 112.383 116.571 113.907 115.047L140.191 88.7621L113.907 62.4758C112.383 60.952 112.383 59.047 113.907 57.5232C115.431 55.9994 117.335 55.9994 118.859 57.5232L147.43 86.0947C148.954 87.6185 148.954 89.5234 147.43 91.0472L118.859 119.619C118.478 120.762 117.336 121.143 116.574 121.143Z"
        fill="#129219"
      />
      <path
        d="M169.524 178.286H95.6212C93.7165 178.286 92.1912 176.762 92.1912 174.857C92.1912 172.952 93.7165 171.429 95.6212 171.429H169.524C182.476 171.429 192.764 161.142 192.764 148.19V30.0949C192.764 17.1425 182.476 6.85733 169.524 6.85733H95.6212C93.7165 6.85733 92.1912 5.33296 92.1912 3.4282C92.1912 1.52344 93.7165 0 95.6212 0H169.524C186.286 0 200 13.7143 200 30.4762V148.571C200 164.571 186.286 178.286 169.524 178.286Z"
        fill="#129219"
      />
    </svg>
  );
}
